<template>
    <div>
        
        <div class="title mb-3">
            <span class="title-01">
                {{ header.text1 }}
            </span>
            <span class="title-02" v-if="header.text2 != null">
                -{{ header.text2 }}
            </span>
            <span class="title-03" v-if="header.text3 != null">
                -{{ header.text3 }}
            </span>
        </div>
    </div>
</template> 
<script>
export default{
    data() {
        return{
            
        }
    },
    props:["header"],
    mounted(){
        this.init();
        this.getpage();
    },
    watch:{

    },
    methods:{
        init(){
        },
        getpage(){
            let page = this.$route.name;
        },
    }
};
</script>